/* assets/token-font.js */
(() => {
  const TOKEN_PATTERNS = [
    { re: /\[\[ppe\]\]([\s\S]*?)\[\[\/ppe\]\]/g, cls: 'ppe' },
    { re: /\[\[sfe\]\]([\s\S]*?)\[\[\/sfe\]\]/g, cls: 'sfe' }
  ];

  /* Nodes likely to contain rich-text HTML */
  const selectors = [
    '.rte',
    '[data-richtext]',
    '[data-product-description]'
  ];

  function swapTokens(root = document) {
    root.querySelectorAll(selectors.join(',')).forEach(el => {
      let html = el.innerHTML;
      TOKEN_PATTERNS.forEach(({ re, cls }) => {
        html = html.replace(re, `<span class="${cls}">$1</span>`);
      });
      el.innerHTML = html;
    });
  }

  document.addEventListener('DOMContentLoaded', () => swapTokens());
  document.addEventListener('shopify:section:load', e => swapTokens(e.target));
})();